import { useEffect } from "react";
import styles from "./CalendarEventItem.module.css";
import PropTypes from "prop-types";
import MT from "./MT_Calendar_Icon.svg";
import EC from "./EC_Calendar_Icon.svg";
import InPersonMeetingIcon from "ManagementTeam/Shared/InPersonMeetingIcon";
import VirtualMeetingIcon from "ManagementTeam/Shared/VirtualMeetingIcon";

import { ChevronRight } from "react-ikonate";
import classNames from "classnames";
import Auth from "shared/@auth";
import { convertTimeZoneDisplayText } from "ManagementTeam/utils/timezone";

/**
 *
 * Displays information about a calendar event
 *
 */

export function CalendarEventItem({ event, onPublish, onClick }) {
  const { hasPermission } = Auth.useContainer();

  var dates = [];
  for (var i = 0; i < event.dates.length; i++) {
    dates.push({
      startsOn: new Date(event.dates[i].startsOn),
      endsOn: new Date(event.dates[i].endsOn),
    });
  }
  // console.log(event.dates[i]);
  useEffect(() => {}, [event]);

  function formatDate(date) {
    var str = date.toLocaleDateString("en-US", { weekday: "long" }) + ", ";
    str +=
      date.toLocaleDateString("en-US", { month: "long" }) +
      " " +
      date.getUTCDate();
    if (date.getYear() != new Date().getYear()) {
      // if the meeting is in a different year as the current year, display the year
      str += ", " + date.getUTCFullYear();
    }
    return str;
  }
  function formatTime(date) {
    var hour = date.getUTCHours();
    var minutes = date.getUTCMinutes();
    var amPm = "AM";
    if (hour > 11) {
      amPm = "PM";
      if (hour > 12) {
        hour -= 12;
      }
    }
    if (hour == 0) {
      hour = 12;
    }

    if (minutes < 10) {
      minutes = "0" + minutes;
    }

    return hour + ":" + minutes + " " + amPm;
  }
  function formatDateForDB(date) {
    var month = date.getUTCMonth() + 1;
    if (month < 10) {
      month = "0" + month;
    }

    var d2 = date.getUTCDate();
    if (d2 < 10) {
      d2 = "0" + d2;
    }

    return date.getUTCFullYear() + "-" + month + "-" + d2;
  }
  function formatTimeForDB(date) {
    var hour = date.getUTCHours().toString();
    if (hour.length < 2) {
      hour = "0" + hour;
    }

    var minutes = date.getUTCMinutes().toString();
    if (minutes.length < 2) {
      minutes = "0" + minutes;
    }

    return hour + ":" + minutes + ":" + "00";
  }

  function getDates() {
    var dates = [];
    for (var i = 0; i < event.dates.length; i++) {
      var sd = new Date(event.dates[i].startsOn);
      dates.push({
        startDate: formatDateForDB(sd),
        startTime: formatTimeForDB(sd),
        endTime: formatTimeForDB(new Date(event.dates[i].endsOn)),
        timeZone: event.dates[0].timeZone,
      });
    }

    return dates;
  }
  function getMeetingReqBody(isDraft) {
    var b = {
      meetingType: event.meetingType,
      deliveryType: event.deliveryType,

      dates: getDates(),
      isDraft: isDraft,
    };

    if (event.inPerson) {
      b.location = event.inPerson.location;
      b.city = event.inPerson.city;
      b.state = event.inPerson.state;
    }

    if (event.virtual) {
      b.zoomLink = event.virtual.zoomLink;
      b.meetingId = event.virtual.meetingId;
      b.meetingPasscode = event.virtual.meetingPasscode;
    }

    b.id = event.id;

    return b;
  }
  function publishOnClick() {
    onPublish(getMeetingReqBody(false));
    event.isDraft = false;
  }

  return (
    <div className={styles.container}>
      <div
        className={classNames(
          styles.header,
          event.meetingType == "EC" && styles.ecBg
        )}
      >
        {formatDate(dates[0].startsOn)}
      </div>

      <div className={styles.grid}>
        <div className={styles.gridLabel}>
          {event.meetingType == "MT" ? (
            <img
              src={MT}
              className={styles.iconMT}
              onClick={() => onClick(event)}
            />
          ) : (
            <img
              src={EC}
              className={styles.iconEC}
              onClick={() => onClick(event)}
            />
          )}
          <div>
            <div
              onClick={() => onClick(event)}
              className={classNames(styles.meetingType, styles.pointerHover)}
            >
              {event.meetingType === "MT"
                ? "Management Team"
                : "Executive Committee"}
            </div>
            <div className={styles.time}>
              {formatTime(dates[0].startsOn)}-{formatTime(dates[0].endsOn)}{" "}
              {convertTimeZoneDisplayText(event.dates[0].timeZone)
                .substring(
                  convertTimeZoneDisplayText(event.dates[0].timeZone)?.length -
                    4
                )
                .toUpperCase()}
            </div>
          </div>
        </div>

        <div className={styles.gridControls}>
          <div className={styles.row}>
            <div className={styles.pointerHover} onClick={() => onClick(event)}>
              {event.inPerson && <InPersonMeetingIcon />}
            </div>
            <div className={styles.pointerHover} onClick={() => onClick(event)}>
              {event.virtual && <VirtualMeetingIcon />}
            </div>
            <div
              className={styles.chevronContainer}
              onClick={() => onClick(event)}
            >
              <ChevronRight
                color="#91B6BB"
                style={{ height: "22px", width: "auto" }}
              />
            </div>
          </div>
          <div
            className={styles.row}
            style={{
              visibility: hasPermission("management-team.admins")
                ? "visible"
                : "hidden",
            }}
          >
            <div>
              {event.isDraft && !event.isComplete && (
                <button
                  className={styles.publishButton}
                  onClick={publishOnClick}
                >
                  Publish
                </button>
              )}
            </div>
          </div>
        </div>
        <div
          className={classNames(
            styles.bottomLine,
            event.meetingType == "EC" && styles.ecBg
          )}
        />
      </div>
    </div>
  );
}

CalendarEventItem.propTypes = {
  event: PropTypes.object,
  onPublish: PropTypes.func,
  onClick: PropTypes.func,
};
